import React from 'react'
import PropTypes from 'prop-types'
import ArticleItem from './components/Article'

const Article = (props) => {
  const {
    category,
    title,
    datetime,
    label,
    content,
    onClick,
    details,
    onClickDetails,
    onClickdownload,
    download,
    showMore,
    showOtherColor,
    source,
    link,
    subtitle,
    important,
  } = props
  return (
    <ArticleItem
      category={category}
      title={title}
      datetime={datetime}
      label={label}
      content={content}
      onClick={onClick}
      details={details}
      download={download}
      onClickdownload={onClickdownload}
      onClickDetails={onClickDetails}
      showMore={showMore}
      showOtherColor={showOtherColor}
      source={source}
      link={link}
      subtitle={subtitle}
      important={important}
    />
  )
}

// 参数类型
Article.propTypes = {
  link: PropTypes.string,
  category: PropTypes.oneOfType([PropTypes.string, PropTypes.node]),
  title: PropTypes.oneOfType([PropTypes.string, PropTypes.node]),
  subtitle: PropTypes.oneOfType([PropTypes.string, PropTypes.node]),
  important: PropTypes.bool,
  datetime: PropTypes.oneOfType([PropTypes.string, PropTypes.node]),
  label: PropTypes.oneOfType([PropTypes.arrayOf, PropTypes.node]),
  content: PropTypes.oneOfType([PropTypes.string, PropTypes.node]),
  source: PropTypes.string,
  details: PropTypes.bool,
  download: PropTypes.string,
  showMore: PropTypes.bool,
  onClick: PropTypes.func,
}

Article.defaultProps = {
  link: '',
  category: '',
  title: '',
  subtitle: '',
  important: '',
  datetime: '',
  label: '',
  download: '',
  showMore: undefined,
  details: undefined,
  content: undefined,
  onClick: undefined,
  source: undefined,
}

export default Article
